import React from "react";
import CRMInputLabelAndErrorWrapComponent from "../CRMInputLabelAndErrorWrapComponent/CRMInputLabelAndErrorWrapComponent";
import { TCRMFormInputPropsWithoutCodec } from "./CRMFormInputTypes";
import { CRMInputCurrency } from "../CRMInputCurrency/CRMInputCurrency";
import { TNumberMode } from "../../hooks/useNumberInput";

export const CRMCurrencyFormInput = (
    props: TCRMFormInputPropsWithoutCodec<number | null> & { mode?: TNumberMode }
): JSX.Element => (
    <CRMInputLabelAndErrorWrapComponent label={props.label}>
        <CRMInputCurrency
            currencySymbol="£"
            value={props.model}
            onChange={props.onChange}
            onPressEnterKey={() => undefined}
            displayError={props.displayError}
            disabled={props.disabled}
            mode={props.mode}
        />
    </CRMInputLabelAndErrorWrapComponent>
);
